export default __webpack_public_path__ + "static/media/image5.97d7ef9d.jpg";